// Centralised data-testid registry — keeps names consistent across pages/tests.
export const TID = {
  // Landing / brand
  landing: {
    root: "landing-root",
    logo: "landing-logo",
    tagline: "landing-tagline",
    joinBtn: "landing-join-btn",
    signInBtn: "landing-signin-btn",
    learnMoreBtn: "landing-learn-more-btn",
    watchOverviewBtn: "landing-watch-overview-btn",
    directionSongwriters: "compass-direction-songwriters",
    directionMusicIndustry: "compass-direction-music-industry",
    directionMerchandising: "compass-direction-merchandising",
    directionServices: "compass-direction-services",
    sectionMission: "section-mission",
    sectionPillars: "section-pillars",
    sectionBenefits: "section-benefits",
    sectionHowItWorks: "section-how-it-works",
    sectionMembership: "section-membership",
    sectionPartners: "section-partners",
    sectionFaq: "section-faq",
    footer: "landing-footer",
  },
  // Auth
  auth: {
    loginForm: "login-form",
    loginEmail: "login-email",
    loginPassword: "login-password",
    loginSubmit: "login-submit",
    loginGoogle: "login-google-btn",
    loginError: "login-error",
    registerForm: "register-form",
    registerName: "register-name",
    registerEmail: "register-email",
    registerPassword: "register-password",
    registerRole: "register-role",
    registerSubmit: "register-submit",
    registerGoogle: "register-google-btn",
    registerError: "register-error",
    toLogin: "auth-to-login",
    toRegister: "auth-to-register",
  },
  // App shell
  shell: {
    sidebar: "app-sidebar",
    header: "app-header",
    breadcrumbs: "app-breadcrumbs",
    userMenu: "app-user-menu",
    logout: "app-logout",
    navPrefix: "nav-",
  },
  // Center Radio hotspot (SS record)
  radioHotspot: "compass-center-radio",
  // Waitlist
  waitlist: {
    section: "section-waitlist",
    form: "waitlist-form",
    firstName: "waitlist-first-name",
    lastName: "waitlist-last-name",
    email: "waitlist-email",
    category: "waitlist-category",
    categoryOption: (v) => `waitlist-category-${v}`,
    comments: "waitlist-comments",
    submit: "waitlist-submit",
    success: "waitlist-success",
    error: "waitlist-error",
    // Admin
    adminRoot: "page-admin-waitlist",
    adminSearch: "waitlist-admin-search",
    adminCategory: "waitlist-admin-category",
    adminSort: "waitlist-admin-sort",
    adminExport: "waitlist-admin-export",
    adminRow: (id) => `waitlist-row-${id}`,
  },
  // Pages
  page: (name) => `page-${name}`,
};
